<template>
	<div class="block block--callout">
		<!-- NEED THIS, block__image will apply display: block !important in certain themes -->
		<div class="d-none block__image" v-if="image">
			<EditableComponent
				:editable="editable"
				edit-label="Edit Image"
				@editClick="handleImageClick"
				applyClick
				:animate="animate"
				@opened="handleOpened"
			>
				<image-preview :source="image" :width="433" :height="433" alt="block image" v-show="!isLoading" />
				<LoadingSpinner v-if="isLoading" />
			</EditableComponent>
		</div>
		<div class="block__content">
			<div class="block__image" v-if="image">
				<EditableComponent
					:editable="editable"
					edit-label="Edit Image"
					@editClick="handleImageClick"
					applyClick
					:animate="animate"
					@opened="handleOpened"
				>
					<!-- Only need to handleLoading on one image-preview since BOTH will still fire (above will still fire) -->
					<image-preview :source="image" :width="433" :height="433" alt="block image" @isLoading="handleLoading" v-show="!isLoading" />
					<LoadingSpinner v-if="isLoading" :wrapperStyles="{ 'aspect-ratio': '1 / 1' }" />
				</EditableComponent>
			</div>
			<div class="block__text">
				<h4 class="block__heading">
					<EditableComponent
						v-model="buttonTitle"
						:editable="editable"
						edit-label="Edit Title"
						@change="handleTitleChange"
						maxlength="50"
						:animate="animate"
						@opened="handleOpened"
					>
						{{ buttonTitle }}
					</EditableComponent>
				</h4>
				<p class="block__subheading">
					<EditableComponent
						v-model="buttonTagline"
						:editable="editable"
						edit-label="Edit Description"
						@change="handleTaglineChange"
						maxlength="100"
						:animate="animate"
						@opened="handleOpened"
					>
						{{ buttonTagline }}
					</EditableComponent>
				</p>
				<div v-if="isPrice" class="price-review">
					<Price :currency="currency" :amount="price.amount" :sale-amount="price.sale_amount_available ? price.sale_amount : 0" />
					<PriceOff v-if="showDiscount" :amount="price.amount" :sale-amount="price.sale_amount_available ? price.sale_amount : 0" />
					<div v-if="isReviews" class="rating" :style="{ '--avg-rating': avgReviews }">
						<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M6.6574 0L8.75579 4.11181L13.3148 4.83688L10.0527 8.10319L10.7719 12.6631L6.6574 10.57L2.5429 12.6631L3.26212 8.10319L0 4.83688L4.559 4.11181L6.6574 0Z"
								fill="#FEC337"
							/>
						</svg>
						<span>{{ avgReviews }}</span>
					</div>
					<div class="flex-linebreak"></div>
					<div v-if="quantity != undefined" class="d-none inventory">
						<span :class="{ 'in-stock': isInStock, 'out-of-stock': !isInStock, 'low-stock': isLowStock }">{{ quantity_text }}</span>
					</div>
				</div>
				<div v-if="quantity != undefined" class="inventory">
					<span :class="{ 'in-stock': isInStock, 'out-of-stock': !isInStock, 'low-stock': isLowStock }">{{ quantity_text }}</span>
				</div>
			</div>

			<div class="d-none cta-button">
				<EditableComponent
					v-model="buttonCTA"
					:editable="editable"
					edit-label="Edit Button Text"
					@change="handleButtonChange"
					maxlength="30"
					:animate="animate"
					@opened="handleOpened"
				>
					<button class="cta-button__button" @click="$emit('buttonClick')">
						<div class="cta-button__label">{{ buttonCTA }}</div>
						<div class="d-none cta-button__icon--right">
							<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M19.4524 8.11813L10.6704 0.695421C10.3454 0.420714 9.84766 0.651735 9.84766 1.07729V15.9227C9.84766 16.3483 10.3454 16.5793 10.6704 16.3046L19.4524 8.88187C19.6887 8.68213 19.6887 8.31787 19.4524 8.11813Z"
									fill="white"
								/>
								<rect x="0.796875" y="6.1842" width="10.321" height="4.73679" rx="0.5" fill="white" />
							</svg>
						</div>
					</button>
				</EditableComponent>
			</div>
		</div>
		<div class="cta-button">
			<EditableComponent
				v-model="buttonCTA"
				:editable="editable && !hiddenButton"
				edit-label="Edit Button Text"
				@change="handleButtonChange"
				maxlength="30"
				:animate="animate"
				@opened="handleOpened"
			>
				<button class="cta-button__button" @click="$emit('buttonClick', { preSelectValue: true })">
					<div class="cta-button__label">{{ buttonCTA }}</div>
					<div class="d-none cta-button__icon--right">
						<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M19.4524 8.11813L10.6704 0.695421C10.3454 0.420714 9.84766 0.651735 9.84766 1.07729V15.9227C9.84766 16.3483 10.3454 16.5793 10.6704 16.3046L19.4524 8.88187C19.6887 8.68213 19.6887 8.31787 19.4524 8.11813Z"
								fill="white"
							/>
							<rect x="0.796875" y="6.1842" width="10.321" height="4.73679" rx="0.5" fill="white" />
						</svg>
					</div>
				</button>
			</EditableComponent>
		</div>
	</div>
</template>
<script>
	import Price from '../Price'
	import PriceOff from '../PriceOff'
	import ImagePreview from '../ImagePreview'
	import { PRODUCT_TYPES } from '../utils'
	import ButtonMixin from './ButtonMixin'
	import Il8nMixin from '../Il8nMixin'
	import EditableComponent from './EditableComponent'

	export default {
		mixins: [ButtonMixin, Il8nMixin],
		components: {
			Price,
			PriceOff,
			ImagePreview,
			EditableComponent,
		},
		props: {
			title: { type: String, default: 'Button' },
			button_text: { type: String, default: 'Button Text' },
			tagline: { type: String, default: 'Subheading text goes here and here subheading text goes here and here.' },
			image: { type: String, default: 'https://assets.stanwith.me/graphics/no__image.svg' },
			user: { type: Object },
			price: { type: Object, default: () => {} },
			reviews: { type: Array, default: () => [] },
			productType: { type: String },
			currency: { type: String },
			showDiscount: { type: Boolean },
			quantity: { type: Number },
			pageId: { type: Number },
			product: { type: Object },
			userPrimaryColor: { type: String },
			editable: { type: Boolean, default: false },
			animate: { type: Boolean, default: false },
		},
		data() {
			return {
				isLoading: false,
				buttonTitle: this.title,
				buttonTagline: this.tagline,
				buttonCTA: this.button_text,
				hiddenButton: false,
			}
		},
		watch: {
			title(text) {
				this.buttonTitle = text
			},
			tagline(text) {
				this.buttonTagline = text
			},
			button_text(text) {
				this.buttonCTA = text
			},
		},
		computed: {
			isPrice() {
				const canShowPrice = this.price !== undefined
				return PRODUCT_TYPES.getLeadGeneratingPages().includes(this.productType) && canShowPrice && !this.editable
			},
			isReviews() {
				return this.isPrice && this.reviews && this.reviews.length > 0
			},
			avgReviews() {
				return this.reviews.length ? (this.reviews.reduce((sum, review) => (sum += review.rating), 0) / this.reviews.length).toFixed(1) : 0.0
			},
			isLowStock() {
				return this.quantity > 0 && this.quantity < 3
			},
			isInStock() {
				return this.quantity === undefined || this.quantity > 0
			},
			quantity_text() {
				if (!this.isInStock) return this.$t('shared.site_button.sold_out')
				else {
					let item_string = this.$t('shared.site_button.item')
					if (this.quantity > 1) item_string = this.$t('shared.site_button.items')
					return `${this.quantity} ${item_string} ${this.$t('shared.site_button.left')}`
				}
			},
		},
		mounted() {
			this.checkIfButtonIsHidden()
		},
		methods: {
			handleTitleChange(text) {
				this.$emit('titleUpdate', text)
			},
			handleTaglineChange(text) {
				this.$emit('taglineUpdate', text)
			},
			handleButtonChange(text) {
				this.$emit('buttonUpdate', text)
			},
			handleImageClick() {
				this.$emit('imageEdit')
			},
			// Some buttons are hidden but take up the entire element, we need to make sure we dont edit this button since its just for click events
			checkIfButtonIsHidden() {
				this.$nextTick(() => {
					const label = this.$el.querySelector('.cta-button__label')
					if (label) {
						const style = window.getComputedStyle(label)
						this.hiddenButton = style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0'
					}
				})
			},
			handleOpened() {
				this.$emit('editorOpened')
			},
		},
	}
</script>
<style lang="scss">
	.cta-button-secondary {
		.cta-button__button {
			width: 100%;
			display: inline-block;
			text-align: center;
			min-height: 60px;

			.cta-button__label {
				font-family: 'Inter';
				font-style: normal;
				font-weight: 500;
				font-size: 14px;
				line-height: normal;
				color: var(--stan-store-theme-primary-color);
				width: 80%;
				margin: 0 auto;
			}
		}
	}
</style>
